import MUIEditIcon from '@mui/icons-material/Edit'

export const EditIcon = MUIEditIcon
